var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewReportDownloadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_147_22",
    "data-name": "Component 147 \\u2013 22",
    transform: "translate(18) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    transform: "translate(-46.523 -5137.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_148_1",
    "data-name": "Component 148 \\u2013 1",
    transform: "translate(46.523 5137.523)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 18,
    height: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "arrow-in",
    d: "M12.322,3H15.43a1.554,1.554,0,0,1,1.554,1.554V15.43a1.554,1.554,0,0,1-1.554,1.554H12.322M8.438,13.876l3.884-3.884L8.438,6.107M11.39,9.992H3",
    transform: "translate(44.603 5136.523)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReportDownloadIcon);
export default __webpack_public_path__ + "static/media/view-report-download-icon.75823f211e0215ec92e507a624598bd7.svg";
export { ForwardRef as ReactComponent };